import Currency from "../money-format";
import { mapProductData } from "../utils";

class RelatedProductsView {
  parentElJQuery = $(".pdp-like__slider");
  parentEl = document.querySelector(".pdp-like__slider");
  _data;

  initSlider() {
    this.parentElJQuery.slick({
      slidesToShow: 5,
      dots: false,
      arrows: true,
      prevArrow: $(".pdp-like__slider__arrow.pdp-like__slider__arrow-prev"),
      nextArrow: $(".pdp-like__slider__arrow.pdp-like__slider__arrow-next"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

  render(prods) {
    this._data = prods;
    if (!this._data || this._data.length < 1) return;

    this.parentElJQuery.slick("unslick");
    this.parentEl.innerHTML = "";

    const markup = this._generateMarkup();
    this.parentEl.insertAdjacentHTML("afterbegin", markup);
    // Yotpo isn't loaded on every theme; a ReferenceError here skips initSlider() and the slides stack vertically.
    if (typeof Yotpo !== "undefined" && window.yotpo) {
      let api = new Yotpo.API(window.yotpo);  api.refreshWidgets();
    }
    console.log('recomendation loaded')
  }

  _clean() {
    this.parentEl.innerHTML = "";
  }

  _generateMarkup() {
    return this._data.map((prod) => this._generateMarkupSlide(prod)).join("");
  }

  _getComparePrice(min, max) {
    if (min >= max) {
      return "";
    } else {
      return max ? Currency.formatMoney(max + "0") : "";
    }
  }

  _localizeText(text) {
    const translations = {
        "Loading...": "جارٍ التحميل...",
        "Add to Cart": "أضف إلى السلة",
        "Out of stock": "نفد من المخزون"
    };
    return window.location.pathname.includes('/ar') ? translations[text] || text : text;
}


  _buildVariantSelector(data) {
    var html = '';
    html = '<div class="product_card_variant-selector-wrapper">';
    console.log('prodprodprod', data.variants, data.variants.length > 0)
    if (data.variants && data.variants.length > 0) {
        // Check if all variants are named "Default Title"
        var hasOnlyDefaultVariant = data.variants.length === 1 && data.variants[0].title.toLowerCase() === "default title";
        var isProductAvailable = data.variants.some(variant => variant.available);

        console.log('hasOnlyDefaultVariant', hasOnlyDefaultVariant)
        if (!hasOnlyDefaultVariant) {
            html += '<span class="product-item-variant-selector_label">' + (data.variants.length > 1 ? 'Select size' : 'One size') + '</span>';
            
            if (data.variants.length > 1) {
              html += "<select class='boost-pfs-filter-product-item-variant-selector' data-variants='" + JSON.stringify(data.variants) + "' >";
                
              if (!isProductAvailable) {
                html += '<option value="" disabled selected>Out of Stock</option>';
              }

                data.variants.forEach(function(variant) {
                let variantId = variant.id;
                  if (variantId && variantId.startsWith('gid://shopify/ProductVariant/')) {
                    variantId = variantId.replace('gid://shopify/ProductVariant/', '');
                  }
                    html += '<option value="' + variantId + '" variant-price="' + Utils.formatMoney(variant.price) + ' " ' + (variant.available ? '' : ' disabled') + ' >' + variant.title + '</option>';
                });
                
                html += '</select>';
            } else {
                html += '<span class="boost-pfs-filter-product-item-single-variant">' + data.variants[0].title + '</span>';
            }
        }
    }
    html += '</div>';
    
    return html;
  }


  _generateMarkupSlide(prod) {

    console.log('prod -------------- ', prod ) ;
    let variantSelectorHtml = this._buildVariantSelector(prod);
    var inputString = prod?.id;
    var regex = /(\d+)/;
    var match = inputString.match(regex);
    if (match) {
      var productIdNumber = match[0];
    } else {
      console.log("No number found in the string");
    }

    // const discountTags = ["10% OFF", "15% OFF", "20% OFF", "25% OFF", "30% OFF", "35% OFF", "40% OFF", "45% OFF", "50% OFF"];
    // const otherTags = ["PRIVATE SALE", "new", "best-seller", "exclusively_online", "sale", "300ml for 111AED", "Limited Edition"];
    // const maxTags = 2;
    // let tagCount = 0;
    // let variantId = prod?.variants[0]?.id;
    // if (variantId && variantId.startsWith('gid://shopify/ProductVariant/')) {
    //   variantId = variantId.replace('gid://shopify/ProductVariant/', '');
    // }

    // const tagsMarkup = [];

    // for (const discount of discountTags) {
    //     if (tagCount >= maxTags) break;
    //     if (prod?.tags?.includes(discount)) {
    //         tagsMarkup.push(`<div class="product-tag home-desk_tp SALE percentage">-${discount.replace(" OFF", "")}</div>`);
    //         tagCount++;
    //     }
    // }

    // if (tagCount < maxTags) {
    //     for (const tag of otherTags) {
    //         if (tagCount >= maxTags) break;
    //         if (prod?.tags?.includes(tag)) {
    //             tagsMarkup.push(`<div class="product-tag home-desk_tp">${tag.toUpperCase().replace(/-|_/g, " ")}</div>`);
    //             tagCount++;
    //         }
    //     }
    // }


    const discountTags = ["10% OFF", "15% OFF", "20% OFF", "25% OFF", "30% OFF", "35% OFF", "40% OFF", "45% OFF", "50% OFF"];
    const otherTags = ["PRIVATE SALE", "new", "best-seller", "exclusively_online", "sale", "300ml for 111AED", "Limited Edition"];
    const maxTags = 3;
    let tagCount = 0;

    // normalize variantId
    let variantId = prod?.variants?.[0]?.id || "";
    if (variantId && variantId.startsWith('gid://shopify/ProductVariant/')) {
      variantId = variantId.replace('gid://shopify/ProductVariant/', '');
    }

    const tagsMarkup = [];

    // 1. Custom “__:” labels
    for (const tag of prod.tags || []) {
      if (tag.startsWith('__:') && tagCount < maxTags) {
        const label = tag.split('__:')[1];
        tagsMarkup.push(`<div class="product-tag home-desk_tp">${label}</div>`);
        tagCount++;
      }
    }

    // 2. Discount tags
    // for (const discount of discountTags) {
    //   if (tagCount >= maxTags) break;
    //   if (prod?.tags?.includes(discount)) {
    //     tagsMarkup.push(
    //       `<div class="product-tag home-desk_tp SALE percentage">-${discount.replace(" OFF", "")}</div>`
    //     );
    //     tagCount++;
    //   }
    // }

    // 3. Other tags
    // Disable other tags for now
    // if (tagCount < maxTags) {
    //   for (const tag of otherTags) {
    //     if (tagCount >= maxTags) break;
    //     if (prod?.tags?.includes(tag)) {
    //       tagsMarkup.push(`<div class="product-tag home-desk_tp">${tag.toUpperCase().replace(/-|_/g, " ")}</div>`);
    //       tagCount++;
    //     }
    //   }
    // }


    return `                     
          <div href="/products/${prod.handle}" class="pdp-like__slider__item product_card_inner ${
      prod.variants[0]?.availableForSale
    }">
    <a href="/products/${prod.handle}">
              <figure class="pdp-like__slider__item__imgbox">
                  <img src="${prod.image?.originalSrc}" alt="${
      prod.image?.altText ? prod.image?.altText : ""
    }" class="pdp-like__slider__item__img"/>
              </figure>

              <div class="product_card--tag-wrapper">
                ${tagsMarkup.join("")}
              </div>
              </a>

              ${variantSelectorHtml}

              <button id="plp-add-to-cart-popup-trigger"  class="product-card-custom-add-to-cart" data-custom-add-to-cart-button data-variant-id="${variantId}" data-soldout-status="${!prod?.productAvailableForSale}" ${!prod?.productAvailableForSale ? 'disabled' : ''}>
                <span class="product-card-custom-add-to-cart-loading">${this._localizeText("Loading...")}</span>  
              <span class="product-card-custom-add-to-cart-text">${this._localizeText("Add to Cart")}</span>
              <span class="product-card-custom-add-to-cart-sold_out">${this._localizeText("Out of stock")}</span>
              </button>

              <button class="BIS_trigger notify_me-btn" data-product-data="${mapProductData({...prod, variants: [{...prod.variants[0], inventory_management: 'shopify'}], })}">
                Notify Me
              </button>

             <a href="/products/${prod.handle}">
              <div class="pdp-like__slider__item__title">${prod?.title}</div>
              <div class="pdp-like__slider__item__price product_card_price" >
                  <div class="pdp-like__slider__item__price__original">${
                    prod?.productMinPrice
                      ? Currency.formatMoney(prod?.productMinPrice + "0")
                      : ""
                  }</div>                
                  <div class="pdp-like__slider__item__price__compare">${this._getComparePrice(
                    prod?.productMinPrice,
                    prod?.productMaxPrice
                  )}</div>                
              </div>
              </a>
              <div class="review-rating-widgets">
              <div class="yotpo bottomLine" data-product-id="${productIdNumber}"></div>
                </div>
          </div>
        `;
  }

  addHandlerLoad(handler) {
    document.addEventListener("DOMContentLoaded", function () {
      console.log('DOMContentLoaded related products');
      handler();
    });
  }
}

export default new RelatedProductsView();
